export default function XButton() {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="20.021" height="20" viewBox="0 0 20.021 20">
        <g id="Group_11511" data-name="Group 11511" transform="translate(-621.718 -135.951)">
            <path id="Line_962" data-name="Line 962" d="M.343.656A.367.367,0,0,1,0,.321.294.294,0,0,1,.3,0L26.49.549a.366.366,0,0,1,.35.335.294.294,0,0,1-.3.321L.351.656Z" transform="translate(622.57 136.119) rotate(45)" fill="#ff2e2e" />
            <path id="Line_963" data-name="Line 963" d="M26.5.666H26.49L.305,1.216A.294.294,0,0,1,0,.894.366.366,0,0,1,.352.56L26.537.01a.294.294,0,0,1,.3.321A.367.367,0,0,1,26.5.666Z" transform="translate(641.746 136.81) rotate(135)" fill="#ff2e2e" />
        </g>
    </svg>
    )
}